import axios from 'axios';
import apiConfig from '../api.config';

export default function communicationChannelsRequest(hotelId) {
  const {
    host,
    URIs: { communicationChannels },
  } = apiConfig;

  const uri = `${host}${communicationChannels.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
